import { Injectable } from '@angular/core';
import { Repository, State } from '@frontend-site/shared/utils';
import { createStore, withProps } from '@ngneat/elf';
import { map } from 'rxjs';
import { Release, ReleaseDetails } from '@frontend-site/shared/data';

export interface ReleaseState extends State {
    releases: Release[] | null;
    currentRelease?: ReleaseDetails | null;
    currentReleaseName?: string;
}

function createInitialState(): ReleaseState {
    return {
        releases: []
    };
}

@Injectable({ providedIn: 'root' })
export class ReleaseStore extends Repository<ReleaseState> {
    readonly releases$ = this.store.pipe(map((x) => x.releases));
    readonly currentRelease$ = this.store.pipe(map((x) => x.currentRelease));
    readonly currentReleaseName$ = this.store.pipe(map((x) => x.currentReleaseName));

    get currentReleaseId(): number | undefined {
        return this.getValue().currentRelease?.id;
    }

    constructor() {
        super(createStore({ name: 'ReleasesStore' }, withProps<ReleaseState>(createInitialState())));
    }

    setReleases(releases: Release[]): void {
        this.update({ releases });
    }

    setCurrentRelease(releaseDetails: ReleaseDetails): void {
        this.update({ currentRelease: releaseDetails });
    }

    setCurrentReleaseName(name: string): void {
        this.update({ currentReleaseName: name });
    }
}
